<div id="user-notification-dropdown" class="nav-item dropdown d-none d-sm-block" [class.d-none]="!isLoggedIn">
  <button
    class="text-dark nav-link dropdown-toggle pr-1 btn"
    placement="left"
    container="body"
    role="button"
    data-toggle="dropdown"
    aria-haspopup="true"
    aria-expanded="false"
    tooltip="View triggered notifications"
    (click)="refreshUserNotifications()"
  >
    <div class="notification-wrapper">
      <app-vficon iconPack="source-mid-render-light-icons" iconName="notification" class="vficon-position"></app-vficon>

      @if (bellUnreadCount > 0) {
        <span class="notification-badge" aria-label="New notifications" title="New notifications"></span>
      }
    </div>
  </button>

  <div class="dropdown-menu dropdown-menu-right bell-dropdown-menu">
    <div class="bell-dropdown-header">
      <div class="bell-dropdown-title-wrap">
        <span class="bell-dropdown-title">Notifications</span>
        <span class="bell-dropdown-subtitle">Actionable updates for your tenancy</span>
      </div>
      <span class="bell-dropdown-count" [class.has-unread]="bellUnreadCount > 0">
        {{ bellUnreadCount > 0 ? "New" : "All caught up" }}
      </span>
    </div>

    <div class="bell-search-container">
      <div class="bell-search-shell">
        <span class="bell-search-icon">Search</span>
        <input
          type="text"
          class="form-control bell-search-input"
          placeholder="Search notifications..."
          [(ngModel)]="bellSearchTerm"
          (click)="$event.stopPropagation()"
        />
      </div>
    </div>

    <div class="bell-tabs" role="tablist" aria-label="Notifications filter">
      <button
        type="button"
        class="bell-tab"
        [class.active]="activeBellView === 'all'"
        (click)="$event.stopPropagation(); setBellView('all')"
      >
        All ({{ bellNotifications.length }})
      </button>
      <button
        type="button"
        class="bell-tab"
        [class.active]="activeBellView === 'unread'"
        (click)="$event.stopPropagation(); setBellView('unread')"
      >
        Unread ({{ bellUnreadCount }})
      </button>
      <button
        type="button"
        class="bell-tab"
        [class.active]="activeBellView === 'high'"
        (click)="$event.stopPropagation(); setBellView('high')"
      >
        High ({{ bellHighCount }})
      </button>
    </div>

    @if (bellNotifications.length > 0) {
      <div class="bell-filters-container">
        <div class="bell-filter-group">
          <label class="bell-filter-label">Type:</label>
          <select
            class="form-control form-control-sm bell-filter-select"
            [(ngModel)]="bellFilterType"
            (click)="$event.stopPropagation()"
          >
            <option value="all">All Types</option>
            @for (type of getAvailableFilterTypes(); track type) {
              <option [value]="type">{{ getNotificationTypeLabel(type) | titlecase }}</option>
            }
          </select>
        </div>

        <div class="bell-filter-group">
          <label class="bell-filter-label">Severity:</label>
          <select
            class="form-control form-control-sm bell-filter-select"
            [(ngModel)]="bellFilterSeverity"
            (click)="$event.stopPropagation()"
          >
            <option value="all">All</option>
            @for (severity of getAvailableFilterSeverities(); track severity) {
              <option [value]="severity">{{ severity | titlecase }}</option>
            }
          </select>
        </div>

        <div class="bell-filter-group">
          <label class="bell-filter-label">Cloud:</label>
          <select
            class="form-control form-control-sm bell-filter-select"
            [(ngModel)]="bellFilterCloudProvider"
            (click)="$event.stopPropagation()"
          >
            <option value="all">All</option>
            @for (provider of getAvailableFilterCloudProviders(); track provider) {
              <option [value]="provider">{{ provider | uppercase }}</option>
            }
          </select>
        </div>

        @if (
          bellSearchTerm ||
          bellFilterType !== "all" ||
          bellFilterSeverity !== "all" ||
          bellFilterCloudProvider !== "all"
        ) {
          <button class="btn btn-sm btn-link bell-reset-filters" (click)="$event.stopPropagation(); resetBellFilters()">
            Reset
          </button>
        }
      </div>
    }

    @if (filteredBellNotifications.length === 0) {
      <div class="bell-empty-state">No triggered notifications right now.</div>
    }

    <div class="bell-notifications-list">
      @for (notification of filteredBellNotifications; track notification.id) {
        <a
          class="bell-dropdown-item"
          [class.unread]="notification.unread"
          [class.excluded]="isExcluded(notification.id)"
          [class.severity-error]="notification.severity === 'error'"
          [class.severity-warning]="notification.severity === 'warning'"
          [class.severity-info]="notification.severity === 'info'"
          [class.severity-success]="notification.severity === 'success'"
          [href]="notification.action_params.url"
          target="_blank"
          rel="noopener noreferrer"
          (click)="markNotificationAsRead(notification, $event)"
        >
          <div class="bell-item-header">
            @if (notification.unread) {
              <span class="bell-item-unread-dot" title="Unread"></span>
            }
            <span class="bell-item-title">{{ notification.headline }}</span>
            <div class="bell-item-time-group">
              <span class="bell-item-time">{{ notification.timestamp | date: "short" }}</span>
            </div>
          </div>

          <p class="bell-item-copy">{{ notification.description }}</p>

          <div class="bell-item-tags">
            <span class="bell-tag bell-tag-provider">{{ notification.cloud_provider.join(", ") | uppercase }}</span>
            <span class="bell-tag bell-tag-type">{{ getNotificationTypeLabel(notification.type) | titlecase }}</span>
            <span class="bell-tag" [class]="'bell-tag-severity-' + notification.severity">{{
              notification.severity | titlecase
            }}</span>
            <span class="bell-tag bell-tag-priority" [class]="'bell-tag-priority-' + notification.priority">{{
              notification.priority | titlecase
            }}</span>
          </div>

          <div class="bell-item-footer">
            <span class="bell-item-action">{{ notification.action_params.label }}</span>
            <button
              type="button"
              class="btn btn-link bell-exclude-toggle"
              [class.is-excluded]="isExcluded(notification.id)"
              (click)="toggleNotificationExclude(notification, $event)"
            >
              {{ isExcluded(notification.id) ? "Unexclude" : "Exclude" }}
            </button>
          </div>
        </a>
      }
    </div>
  </div>
</div>
